import _ from 'lodash'

export default {
  name: 'audioPlayer',
  components: {
  },
  props: {
    playlistProp: {
      default () { return [] }
    },
    updateAudioPlayerProp: {
      default () { return {} }
    },
    elClassProp: {
      default () { return {} }
    },
    parentComponentItemSelectionProp: {
      default () { return [] }
    },
    accessorComponentProp: {
      default () { return 'projectAudio' }
    },
    autoPlayWhenAudioPlayerDataChangedProp: {
      default () { return true }
    }
  },
  watch: {
    playlistProp: {
      handler (newVal, prevVal) {
        if (['mediaFilesPage', 'ledPage'].indexOf(this.accessorComponentProp) >= 0) {
          if ((newVal.length === 1 && prevVal.length === 1) && ((newVal[0].resourceId && newVal[0]) && (newVal[0].resourceId === prevVal[0].resourceId))) {
            return
          }
        }

        this.playlist.currentIndex = 0
        this.playlist.songs = _.cloneDeep(newVal)
        this.resetMainData()
        this.setDefaultAudioPlayerAndData()
      },
      deep: true
    },
    updateAudioPlayerProp: {
      handler (newVal) {
        this.updateAudioPlayer(newVal)
        this.handleCumulativeTimeStatus()
      },
      deep: true
    },
    parentComponentItemSelectionProp: {
      handler (newVal) {
        this.parentComponentItemSelection = newVal
        this.handleCumulativeTimeStatus()
        this.resetCommulativeTimeData()
      },
      deep: true
    },
    accessorComponentProp (newVal) {
      this.accessorComponent = newVal
    },
    autoPlayWhenAudioPlayerDataChangedProp (newVal) {
      this.autoPlayWhenAudioPlayerDataChanged = newVal
    }
  },
  mixins: [],
  data () {
    return {
      updateAudioPlayerData: this.updateAudioPlayerProp,
      previousPlaylistIndex: 0,
      playlist: {
        currentIndex: 0,
        songs: _.cloneDeep(this.playlistProp)
      },
      defaultSong: '',
      isPlaying: false,
      isLoaded: false,
      isCurrentlyPlaying: '',
      onRepeat: false,
      shuffle: false,
      loop: {
        state: false,
        value: 1
      },
      durationSeconds: 0,
      currentSeconds: 0,
      audioPlayer: undefined,
      previousVolume: 35,
      volume: 100,
      autoPlay: false,
      progressPercentageValue: '0%',
      currentSong: {
        resourceId: null,
        uid: null,
        title: null,
        artist: null,
        album: null,
        coverArt: null
      },
      showPlaylist: false,
      parentComponentItemSelection: this.parentComponentItemSelectionProp,
      accessorComponent: this.accessorComponentProp,
      autoPlayWhenAudioPlayerDataChanged: this.autoPlayWhenAudioPlayerDataChangedProp,
      currentSongDuration: 0,
      prevSongDuration: 0,
      prevCumulativeCurrentPlayedTime: 0,
      totalDurationAllSongs: 0,
      enableCumulativeTime: false,
      calculateCumulativeTime: true,
      playlistSummary: {
        numberOfSongs: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('audio-player-change', { action, payload: { data } })
      }
    },
    setDefaultAudioPlayerAndData () {
      // Set Audio Player
      this.audioPlayer = this.$refs.audiofile
      this.audioPlayer.addEventListener('timeupdate', this.handleSongTimer)
      this.audioPlayer.addEventListener('loadeddata', this.handleLoadedSong)
      this.audioPlayer.addEventListener('pause', () => { this.isPlaying = false })
      this.audioPlayer.addEventListener('play', () => { this.isPlaying = true })
      this.audioPlayer.addEventListener('ended', this.handleEndedSong)

      // Set cumulative Time and total duration of all songs
      let prevEndSongDuration = 0
      this.playlist.songs.forEach((song, indx) => {
        const timeRange = {
          start: null,
          end: 0,
          origSongDuration: song.dur,
          sliderAllocationInPercent: 0,
          sliderAllocationInPercentRangeFrom: 0,
          sliderAllocationInPercentRangeTo: 0
        }

        if (song.dur) {
          this.totalDurationAllSongs += song.dur
          timeRange.start = prevEndSongDuration
          timeRange.end = prevEndSongDuration + song.dur
          timeRange.origSongDuration = song.dur
        }

        prevEndSongDuration += (song.dur) ? song.dur : 0

        this.playlist.songs[indx].uiCumulativeTimeRange = timeRange
      })

      // Set song percentage allocation in slider for cumulative Time
      let prevPercentRange = 0
      this.playlist.songs.forEach((song, indx) => {
        this.playlist.songs[indx].uiCumulativeTimeRange.sliderAllocationInPercent = (song.dur / this.totalDurationAllSongs) * 100
        this.playlist.songs[indx].uiCumulativeTimeRange.sliderAllocationInPercentRangeFrom = prevPercentRange
        this.playlist.songs[indx].uiCumulativeTimeRange.sliderAllocationInPercentRangeTo = prevPercentRange += this.playlist.songs[indx].uiCumulativeTimeRange.sliderAllocationInPercent

        prevPercentRange = this.playlist.songs[indx].uiCumulativeTimeRange.sliderAllocationInPercentRangeTo
      })

      // Set cumulative time status
      this.handleCumulativeTimeStatus()

      // Set PlaylistSummary
      this.playlistSummary = {
        numberOfSongs: this.playlist.songs.length,
        hours: Math.floor(this.totalDurationAllSongs / 3600),
        minutes: Math.floor(this.totalDurationAllSongs % 3600 / 60),
        seconds: Math.floor(this.totalDurationAllSongs % 3600 % 60)
      }

      // Set Player Data
      if (this.playlist.songs.length) {
        // Make sure first song has audio preview
        const getFirstSongIndxWithPreview = this.playlist.songs.findIndex((song) => { return song.audioPreview })
        if (getFirstSongIndxWithPreview >= 0) {
          const songDetails = this.playlist.songs[getFirstSongIndxWithPreview]
          this.audioPlayer.src = songDetails.audioPreview.url
          this.setCurrentSong(songDetails)
          this.playlist.currentIndex = getFirstSongIndxWithPreview
        }

        // Auto play song
        if (this.autoPlayWhenAudioPlayerDataChanged) {
          this.audioPlayer.play()
          this.isPlaying = true
          this.emitEvent('PLAY_DEFAULT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
        }
      } else {
        this.resetMainData()
        this.audioPlayer.pause()
        this.audioPlayer.src = null
        this.isPlaying = false
        this.pause()
      }
    },
    handleCumulativeTimeStatus () {
      this.enableCumulativeTime = false
    },
    setCurrentSong (song) {
      const currentSong = {
        resourceId: song.resourceId,
        uid: song.uid,
        name: song.name,
        metadata: song.metadata ? song.metadata : null,
        coverArt: song.preview ? song.preview : { type: null, url: null },
        backgroundColor: song._edit ? song._edit.backgroundColor : null,
        textLabel: song._edit ? song._edit.textLabel : null
      }

      this.previousPlaylistIndex = this.playlist.currentIndex
      this.currentSong = currentSong
    },
    updateAudioPlayer (params) {
      if (params.action === 'playAudioPreview') {
        let findCurrentIndx = this.playlist.songs.findIndex((item) => { return (item.uid && params.data && params.data.uid) && (item.uid === params.data.uid) })

        if (findCurrentIndx < 0) {
          findCurrentIndx = this.playlist.songs.findIndex((item) => { return (item.resourceId && params.data && params.data.resourceId) && (item.resourceId === params.data.resourceId) })
        }

        this.playlist.currentIndex = findCurrentIndx
        this.previousPlaylistIndex = this.playlist.currentIndex
        this.audioPlayer.src = this.playlist.songs[this.playlist.currentIndex].audioPreview.url
        this.setCurrentSong(this.playlist.songs[this.playlist.currentIndex])
        this.audioPlayer.play()
        this.isPlaying = true
        this.emitEvent('PLAY_NEXT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })

        // Set previous songs duration from the total of all durations in lower index
        if (this.calculateCumulativeTime) {
          if (findCurrentIndx > 0) {
            let totalPrevDuration = 0
            for (let i = 0; i < findCurrentIndx; i++) {
              totalPrevDuration += this.playlist.songs[i].dur
            }
            this.prevSongDuration = totalPrevDuration
          } else {
            this.prevSongDuration = 0
          }
        }
      }

      if (params.action === 'pauseAudioPreview') {
        this.audioPlayer.pause()
        this.isPlaying = false
        this.pause()
      }

      if (params.action === 'updateAudioPreviewCurrentSong') {
        let findCurrentIndx = this.playlist.songs.findIndex((item) => { return (item.uid && params.data && params.data.uid) && (item.uid === params.data.uid) })

        if (findCurrentIndx < 0) {
          findCurrentIndx = this.playlist.songs.findIndex((item) => { return (item.resourceId && params.data && params.data.resourceId) && (item.resourceId === params.data.resourceId) })
        }

        this.playlist.currentIndex = findCurrentIndx
        this.previousPlaylistIndex = this.playlist.currentIndex
        this.audioPlayer.src = this.playlist.songs[this.playlist.currentIndex].audioPreview.url
        this.setCurrentSong(this.playlist.songs[this.playlist.currentIndex])
        this.audioPlayer.pause()
        this.isPlaying = false
        this.emitEvent('CURRENT_SONG_UPDATED', { currentSong: this.currentSong, isPlaying: this.isPlaying })
      }

      if (params.action === 'resetAudioPlayer') {
        this.audioPlayer.pause()
        this.resetMainData()
        this.setDefaultAudioPlayerAndData()
      }
    },
    resetMainData () {
      this.audioPlayer.src = null
      this.previousPlaylistIndex = 0
      this.playlist = {
        currentIndex: 0,
        songs: _.cloneDeep(this.playlistProp)
      }
      this.isPlaying = false
      this.isCurrentlyPlaying = ''
      this.onRepeat = false
      this.shuffle = false
      this.loop = {
        state: false,
        value: 1
      }
      this.durationSeconds = 0
      this.currentSeconds = 0
      this.progressPercentageValu = '0%'
      this.currentSong = {
        resourceId: null,
        uid: null,
        title: null,
        artist: null,
        album: null,
        coverArt: null
      }

      this.currentSongDuration = 0
      this.prevSongDuration = 0
      this.prevCumulativeCurrentPlayedTime = 0
      this.totalDurationAllSongs = 0
      this.enableCumulativeTime = false
    },
    handleSongTimer () {
      if (this.enableCumulativeTime) {
        this.currentSeconds = parseInt(this.audioPlayer.currentTime)
        this.progressPercentageValue = (parseInt(this.prevSongDuration + this.currentSeconds) / parseInt(this.totalDurationAllSongs) * 100 || 0) + '%'
      } else {
        this.currentSeconds = parseInt(this.audioPlayer.currentTime)
        this.progressPercentageValue = (this.currentSeconds / parseInt(this.audioPlayer.duration) * 100 || 0) + '%'
      }
    },
    handleLoadedSong () {
      if (this.audioPlayer.readyState >= 2) {
        this.isLoaded = true
        this.durationSeconds = parseInt(this.audioPlayer.duration)
        this.currentSongDuration = this.audioPlayer.duration
      } else {
        throw new Error('Failed to load sound file.')
      }
    },
    handleEndedSong () {
      this.prevSongDuration += this.audioPlayer.duration

      if (this.playlist.songs.length > 1) {
        // Set next song index
        if (this.playlist.currentIndex === this.previousPlaylistIndex) this.playlist.currentIndex += 1
        let nextAudioSource = (this.playlist.songs[this.playlist.currentIndex] && this.playlist.songs[this.playlist.currentIndex].audioPreview) ? this.playlist.songs[this.playlist.currentIndex].audioPreview.url : null

        if (this.onRepeat && this.loop.value === 'all') { // If repeat is on then replay from the top
          this.playlist.currentIndex = 0
          nextAudioSource = (this.playlist.songs[0].audioPreview) ? this.playlist.songs[0].audioPreview.url : null
        }

        if (this.enableCumulativeTime) {
          this.resetCommulativeTimeData()
        }

        // If current song has no url then find next song with url
        if (!nextAudioSource) {
          for (let i = this.playlist.currentIndex; i < this.playlist.songs; i++) {
            if (this.playlist.songs[i].audioPreview) {
              this.playlist.currentIndex = i
              break
            }
          }
        }

        if (this.playlist.currentIndex >= this.playlist.songs.length) {
          if (this.onRepeat && this.loop.value === 'all') { // If repeat is on then replay from the top
            this.playlist.currentIndex = 0
            nextAudioSource = (this.playlist.songs[0].audioPreview) ? this.playlist.songs[0].audioPreview.url : null
          }

          this.emitEvent('ENDED_ALL_SONGS', { currentSong: this.currentSong, isPlaying: this.isPlaying })
          return
        }

        // Play Next Song
        this.audioPlayer.src = nextAudioSource
        this.setCurrentSong(this.playlist.songs[this.playlist.currentIndex])
        this.audioPlayer.play()
        this.isPlaying = true
        this.playlist.currentIndex++

        if (!this.parentComponentItemSelection.length) {
          this.emitEvent('PLAY_NEXT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
        } else {
          this.emitEvent('ENDED_SONG_PLAY_AND_SELECT_NEXT', { currentSong: this.currentSong, isPlaying: this.isPlaying })
        }
      } else {
        this.emitEvent('ENDED_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
      }
    },
    seek (e) {
      if (this.isLoaded) {
        // calculating the portion of the song based on where the user clicked
        const el = e.target.getBoundingClientRect()
        const seekPos = (e.clientX - el.left) / el.width
        const seekPosPercentage = seekPos * 100
        const songPlayTimeAfterSeek = parseInt(this.audioPlayer.duration * seekPos)

        if (this.enableCumulativeTime) {
          // Pick the song within this range
          const getSongIndx = this.playlist.songs.findIndex((song) => { return (seekPosPercentage >= song.uiCumulativeTimeRange.sliderAllocationInPercentRangeFrom) && (seekPosPercentage <= song.uiCumulativeTimeRange.sliderAllocationInPercentRangeTo) })

          if (getSongIndx >= 0) {
            const songDetails = this.playlist.songs[getSongIndx]
            this.audioPlayer.src = songDetails.audioPreview.url
            this.playlist.currentIndex = getSongIndx
            this.setCurrentSong(songDetails)
            this.audioPlayer.currentTime = songPlayTimeAfterSeek
            this.audioPlayer.play()
            this.isPlaying = true

            // Set previous songs duration from the total of all durations in lower index
            if (getSongIndx > 0) {
              let totalPrevDuration = 0
              for (let i = 0; i < getSongIndx; i++) {
                totalPrevDuration += this.playlist.songs[i].dur
              }
              this.prevSongDuration = totalPrevDuration
            }

            this.progressPercentageValue = (parseInt(this.prevSongDuration + seekPosPercentage) / parseInt(this.totalDurationAllSongs) * 100 || 0) + '%'
          }
        } else {
          this.audioPlayer.currentTime = songPlayTimeAfterSeek
          this.progressPercentageValue = seekPosPercentage + '%'
        }
      } else {
        throw new Error('Song Not Loaded')
      }
    },
    repeat (type) {
      if (type === 'singleSong') {
        if (!this.loop.state && !this.onRepeat) {
          // firstclick
          this.loop.state = true
          this.loop.value = 1
          this.onRepeat = true
        } else if (this.loop.state && this.onRepeat && this.loop.value === 1) {
          // second click
          this.loop.state = false
          this.loop.value = 0
          this.onRepeat = false
        }
      } else if (type === 'multiSongs') {
        if (!this.loop.state && !this.onRepeat) {
          // firstclick
          this.loop.state = true
          this.loop.value = 1
          this.onRepeat = true
        } else if (this.loop.state && this.onRepeat && this.loop.value === 1) {
          // second click
          this.loop.state = true
          this.loop.value = 'all'
          this.onRepeat = true
        } else if (this.loop.state && this.onRepeat && this.loop.value === 'all') {
          this.loop.state = false
          this.loop.value = 1
          this.onRepeat = false
        }
      }
    },
    resetCommulativeTimeData () {
      this.currentSeconds = 0
      this.currentSongDuration = 0
      this.prevSongDuration = 0
      this.prevCumulativeCurrentPlayedTime = 0
    },
    formatTime (secs) {
      const minutes = Math.floor(secs / 60) || 0
      const seconds = Math.floor(secs - minutes * 60) || 0
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds
    },
    mute () {
      // this.muted is a computed variable available down below
      this.audioPlayer.muted = !this.audioPlayer.muted
    },
    toggleShowPlaylist () {
      this.showPlaylist = !this.showPlaylist
    },
    skip (direction) {
      if (!this.playlist.songs.length) return

      if (direction === 'forward') {
        this.playlist.currentIndex += 1

        // If current song has no url then find next song with url
        if (this.playlist.songs[this.playlist.currentIndex] && !this.playlist.songs[this.playlist.currentIndex].audioPreview) {
          let i = this.playlist.currentIndex
          for (i; i <= this.playlist.songs.length; i++) {
            if (this.playlist.songs[i].audioPreview && this.playlist.songs[i].audioPreview.url) {
              this.playlist.currentIndex = i
              break
            }
          }
        }
      } else if (direction === 'backward') {
        this.playlist.currentIndex -= 1

        // If current song has no url then find next song with url
        if (this.playlist.songs[this.playlist.currentIndex] && !this.playlist.songs[this.playlist.currentIndex].audioPreview) {
          let i = this.playlist.currentIndex
          for (i; i < this.playlist.songs.length; i++) {
            if (i !== -1 && this.playlist.songs[i].audioPreview && this.playlist.songs[i].audioPreview.url) {
              this.playlist.currentIndex = i
              break
            }
          }
        }
      }

      /** if the current Index of the playlist is greater or equal to the length of the playlist songs (the index is out of range)
       reset the index to 0. It could also mean that the playlist is at its end. */

      if (this.playlist.currentIndex >= this.playlist.songs.length) {
        this.playlist.currentIndex = 0
      }

      if (this.playlist.currentIndex < 0) {
        this.playlist.currentIndex = this.playlist.songs.length - 1
      }

      this.audioPlayer.src = this.playlist.songs[this.playlist.currentIndex].audioPreview.url
      this.setCurrentSong(this.playlist.songs[this.playlist.currentIndex])

      // the code below checks if a song is playing so it can go ahead and auto play
      if (this.isPlaying) {
        this.audioPlayer.play()
        this.emitEvent('PLAY_NEXT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
      }
    },
    playCurrentSong () {
      if (!this.playlist.songs.length) {
        this.emitEvent('NO_CURRENT_SONG_TO_PLAY', {})
        return
      }

      if (this.parentComponentItemSelection.length >= 0) {
        const isCurrentSongPresentFromSelection = this.parentComponentItemSelection.find((uid) => { return (this.currentSong && this.currentSong.uid) && (uid === this.currentSong.uid) }) >= 0

        if (isCurrentSongPresentFromSelection) {
          this.audioPlayer.play()
          this.isPlaying = true
          this.emitEvent('PLAY_CURRENT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
        } else {
          this.emitEvent('PLAY_NEW_SELECTED_SONG', { uid: this.parentComponentItemSelection[0] })
        }
      } else {
        this.emitEvent('NO_CURRENT_SONG_TO_PLAY', {})
      }
    },
    pause () {
      this.audioPlayer.pause()
      this.isPlaying = false
      this.emitEvent('PAUSE_CURRENT_SONG', { currentSong: this.currentSong, isPlaying: this.isPlaying })
    },
    play (song = {}) {
      if (typeof song === 'object') {
        if (this.isLoaded) {
          // check if song exists in playlist

          if (this.currentSong.id === song.id && this.isPlaying) {
            this.pause()
          } else if (this.currentSong.id === song.id && !this.isPlaying) {
            this.playCurrentSong()
          } else if (this.currentSong.id !== song.id) {
            if (!this.containsObjectWithSameId(song, this.playlist.songs)) {
              this.addToPlaylist(song)
            }

            this.setAudio(song.url)
            this.setCurrentSong(song)
            this.playlist.currentIndex = this.getObjectIndexFromArray(
              song,
              this.playlist.songs
            )
            this.previousPlaylistIndex = this.playlist.currentIndex
            this.audioPlayer.play()
          }
        } else {
          this.setAudio(song.url)
          this.audioPlayer.play()
        }

        this.isPlaying = true
      } else {
        throw new Error('Type Error : Song must be an object')
      }
    }
  },
  computed: {
    sortDraggableOptions () {
      return { animation: 0, group: 'description', disabled: false, ghostClass: 'ghost' }
    },
    currentPlayedTime () {
      return this.formatTime(this.currentSeconds)
    },
    cumulativeCurrentPlayedTime () {
      return this.formatTime(this.prevSongDuration + this.currentSeconds)
    },
    totalDurationAllSongsFormat () {
      return this.formatTime(this.totalDurationAllSongs)
    },
    duration () {
      return this.formatTime(this.durationSeconds)
    },
    progressPercentage () {
      return parseInt(this.currentSeconds / this.durationSeconds * 100)
    },
    muted () {
      // this returns true or false
      return this.volume / 100 === 0
    }
  },
  mounted () {
    this.setDefaultAudioPlayerAndData()
  }
}
